
const navigationModal = document.querySelector('aside.mous-navigation-modal-section .navigation-modal');
const navigationModalOuter = document.querySelector('aside.mous-navigation-modal-section');
const body = document.querySelector('body');

let currentPageLevel = navigationModal.dataset.navigationLevel;

const breadcrumbHistory = [];

if ( navigationModal && navigationModalOuter ) {    
    document.body.addEventListener('click', (e) => {
        const target = e.target;
        const activePage = navigationModal.querySelector('.navigation-page.active-page');
        
        if ( target.closest('[open-navigation-modal]') || target.closest('[href="#open-navigation-modal"]') ) {
            e.preventDefault();
            navigationModalOuter.classList.add('modal-open');
            body.classList.add('locked');
            // console.log('🚀🚀🚀 Clicked a Navigation Modal open trigger!');
            
        } else if ( target.closest('[close-navigation-modal]') || target.classList.contains('mous-navigation-modal-section') ) {
            navigationModalOuter.classList.remove('modal-open');
            body.classList.remove('locked');
            // console.log('🚀🚀🚀 Clicked a Navigation Modal close trigger!');
            
        } else if ( target.getAttribute('data-navigation-child-handle') != null ) {
            e.preventDefault();
            const targetPage = navigationModal.querySelector(`[data-navigation-parent-handle="${ target.getAttribute('data-navigation-child-handle') }"]`)
            // console.log('Clicked Page Trigger', target.getAttribute('data-navigation-child-handle'));
            
            
            if ( activePage && targetPage ) {
                
                breadcrumbHistory.push( target.textContent );
                
                // Remove Current Active Page 
                activePage.classList.remove('active-page');
                
                // Add New Active Page
                targetPage.classList.add('active-page');
                
                currentPageLevel = targetPage.dataset.navigationLevel;
                navigationModal.setAttribute('data-active-page', currentPageLevel);
                // console.log( 'targetPage: ', targetPage, ' | currentPageLevel: ', currentPageLevel );
                updateStepHeadings( breadcrumbHistory );
            }
            
        } else if ( target.getAttribute('navigation-modal-back') != null ) {
            const lastPage = navigationModal.querySelector(`[data-navigation-child-handle="${ activePage.getAttribute('data-navigation-parent-handle') }"]`)?.closest('.navigation-page');
            
            if ( lastPage && activePage ) {
                
                // Update Breadcrumbs
                breadcrumbHistory.pop();
                
                currentPageLevel = lastPage.dataset.navigationLevel;
                // console.log('lastPage: ', lastPage, ' | currentPageLevel: ', currentPageLevel);
                
                if ( lastPage && activePage ) {
                    activePage.classList.remove('active-page');
                    lastPage.classList.add('active-page');
                    
                    updateStepHeadings( breadcrumbHistory );
                    
                    
                    navigationModal.setAttribute('data-active-page', currentPageLevel);
                }
            }
        }
        
    });
    
}

function updateStepHeadings ( breadcrumbHistory ) {
    const navigationModalSteps = navigationModal.querySelectorAll('.navigation-steps .step-heading');
    const stepTranslation = document.querySelector('aside.mous-navigation-modal-section .navigation-modal').getAttribute('data-step-prefix');
    
    if ( navigationModalSteps ) {
        navigationModalSteps.forEach( ( breadcrumb, i ) => {
            const breadcrumbLevel = parseInt( breadcrumb.dataset.navigationLevel );
            
            if ( breadcrumbHistory[i] && breadcrumbHistory != '' ) {
                breadcrumb.innerHTML = breadcrumbHistory[i];
            } else {
                breadcrumb.innerHTML = `${ stepTranslation } ${ breadcrumbLevel }`;
            }
            
        });
    }
}